import Marquee from "react-fast-marquee";

const words = [
  "Green Cardamom", "Basmati Rice", "Turmeric Finger", "Cold-Pressed Oils",
  "Black Pepper", "Millets", "Makhana", "Desi Ghee", "Raw Honey", "Woven Textiles",
];

export default function MarqueeStrip() {
  return (
    <section className="relative z-10 border-y border-brand-border bg-brand-soft py-6" data-testid="marquee-strip">
      <Marquee gradient={false} speed={38} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-3xl text-brand-fg/80 px-8">{w}</span>
            <span className="text-brand-gold text-xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
